import { render } from "./notifications.vue?vue&type=template&id=45ea5572&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=45ea5572&scoped=true&lang=css&external"
import "./notifications.vue?vue&type=style&index=1&id=45ea5572&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ea5572"]])

export default __exports__